import React, { useState } from 'react'
import { ErrorNotification, NothingMessage, Texto, GraviButton } from '@gravitate-js/excalibrr'
import { Button, Col, Divider, Form, Input, Row, Space } from 'antd'
import {
  CheckCircleFilled,
  CheckOutlined,
  CloseCircleFilled,
  CloseOutlined,
  DeleteFilled,
  EditFilled,
  PlusOutlined,
} from '@ant-design/icons'
import api from '@utils/api'
export const SupplyZoneDrawer = ({ supplyZones, setSupplyZones, closeDrawer }) => {
  const [creating, setCreating] = useState(false)
  const [supplyId, setSupplyId] = useState()
  const [saveDisabled, setSaveDisabled] = useState(true)

  const handleSupplyZoneSave = (value) => {
    api
      .createSupplyZone(value)
      .then((resp) => {
        const newZone = resp.data
        setSupplyZones([...supplyZones, { ...newZone }])
        setCreating(false)
        setSaveDisabled(true)
      })
      .catch(() => {
        setCreating(false)
        closeDrawer()
        setSaveDisabled(true)
      })
  }
  const renameSupplyZone = (values, id) => {
    const { new_name } = values
    api
      .renameSupplyZone(id, new_name)
      .then(() => {
        const updatedZone = supplyZones.find((zone) => zone.supply_zone_id === id)
        if (updatedZone) {
          updatedZone.name = new_name
        }
        closeDrawer()
        setSaveDisabled(true)
        setSupplyId(undefined)
      })
      .catch(() => {
        closeDrawer()
        setSaveDisabled(true)
        setSupplyId(undefined)
      })
  }
  const deleteSupplyZone = (id) => {
    api
      .deleteSupplyZone(id)
      .then((resp) => {
        if (resp.data === true) {
          const removeZone = supplyZones.filter((zone) => zone.supply_zone_id !== id)
          setSupplyZones(removeZone)
          closeDrawer()
        }
      })
      .catch(() => closeDrawer())
  }

  return (
    <>
      <Row justify='space-between' align='top' className='pb-4 pr-5 pl-5'>
        <Texto appearance='medium' category='heading-small'>
          ACTIVE ZONES
        </Texto>
        {!creating && (
          <GraviButton theme2 appearance='outlined' icon={<PlusOutlined />} onClick={() => setCreating(true)}>
            ADD ZONE
          </GraviButton>
        )}
      </Row>

      {creating && (
        <Form
          name='supply-zone'
          wrapperCol={{ span: 12 }}
          initialValues={{ remember: true }}
          onFinish={handleSupplyZoneSave}
          onFinishFailed={ErrorNotification}
          autoComplete='off'
        >
          <Row className='supply-zone-form-row py-3 mb-3' align='middle'>
            <Col flex={3} className='pl-5 pt-2'>
              <Form.Item name='name' className='mb-1'>
                <Input placeholder='Enter Zone Name' onChange={() => setSaveDisabled(false)} />
              </Form.Item>
            </Col>

            <Col className='pr-5'>
              <GraviButton
                size='small'
                className='mr-2'
                onClick={() => {
                  setSaveDisabled(true)
                  setCreating(false)
                }}
                buttonText='Cancel'
              />

              <GraviButton htmlType='submit' size='small' theme2 disabled={saveDisabled} icon={<CheckOutlined />} />
            </Col>
          </Row>
        </Form>
      )}

      {supplyZones.length
        ? supplyZones.map((zone, index) => {
            return (
              <Form
                wrapperCol={{ span: 12 }}
                id='rename_supply_zone'
                key={index}
                onFinish={(values) => renameSupplyZone(values, zone.supply_zone_id)}
                onFinishFailed={<ErrorNotification />}
              >
                <Row className='bg-1 supply-zone-row pb-2 pr-5 pl-5'>
                  <Col flex={3} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    {supplyId === zone.supply_zone_id ? (
                      <Form.Item name='new_name' className='mb-1 pt-1'>
                        <Input className='mb-0' defaultValue={zone.name} onChange={() => setSaveDisabled(false)} />
                      </Form.Item>
                    ) : (
                      <Texto category='h6'>{zone.name}</Texto>
                    )}
                    <Texto appearance='hint'>{zone.location_count || '0'} terminals</Texto>
                  </Col>
                  <Space>
                    <Col>
                      {!zone.location_count && !supplyId && (
                        <GraviButton
                          className='delete-supply-zone'
                          error
                          shape='circle'
                          size='small'
                          icon={<DeleteFilled onClick={() => deleteSupplyZone(zone.supply_zone_id)} />}
                        />
                      )}
                    </Col>
                    <Col>
                      {supplyId === zone.supply_zone_id ? (
                        <Space>
                          <Form.Item>
                            <GraviButton
                              size='small'
                              onClick={() => {
                                setSaveDisabled(true)
                                setSupplyId(undefined)
                              }}
                            >
                              Cancel
                            </GraviButton>
                          </Form.Item>
                          <Form.Item>
                            <GraviButton
                              htmlType='submit'
                              theme2
                              size='small'
                              icon={<CheckOutlined />}
                              disabled={saveDisabled}
                            />
                          </Form.Item>
                        </Space>
                      ) : (
                        <GraviButton
                          size='small'
                          icon={<EditFilled onClick={() => setSupplyId(zone.supply_zone_id)} />}
                        />
                      )}
                    </Col>
                  </Space>
                  <Divider orientation='bottom' className='m-1 mt-2 p-1' />
                </Row>
              </Form>
            )
          })
        : !creating && <NothingMessage title='No Zones Found' className='supply-zone-nothing' />}
    </>
  )
}
